import React from "react";
import './ComoPagarMembresia.scss'
import iconoPdf from '../../assets/icons/manuales/icono_pdf.png'
import Button from "../../components/atoms/Button/Button";

const ComoPagarMembresia = ({ pdfs }) => {
    return (
        <div className="ComoPagarMembresia">

            <div className="filas">
                <div className="col1">
                    <div className="textCenter titlePdf">MANUALES</div>
                    <div className="scroll">
                        {
                            pdfs?.map((item) => {
                                return (
                                    <>
                                        <div className="pdfContainer">
                                            <div className="iconPdf">
                                                <img src={iconoPdf} alt="" />
                                            </div>
                                            <div className="informationContainer">
                                                <div className="titlePdf">{item.titulo}</div>
                                                <div className="titlePdf">{item.categoria}</div>
                                                <div className="informationPdf">{item.descripcion}</div>
                                                <a className="linkPdf" href={item.link}>Abrir el manual</a>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="col2">
                    <div className="textCenter titlePdf">VIDEO</div>

                    <div className="containerVideo">
                        <iframe
                            className="v-iframe"
                            src={'https://www.youtube.com/embed/D30LAzub2gs'}
                            title={"Como pagar membresias"}
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                        ></iframe>
                        <div className=" footerVideo">Como pagar membresias</div>
                    </div>
                </div>
                <div className="col3">
                    <div className="textCenter titlePdf">PROMOCIÓN DE PAGOS</div>
                    <div className="containerPagos">
                        <div className="containerPromo">
                            <div className="promo">.</div>
                            <div className="promo">.</div>
                        </div>
                        <div className="containerPromo">
                            <div className="promo">.</div>
                            <div className="promo">.</div>
                        </div>
                        <div className="containerBotonPagos">
                            <div className="boton">
                                <Button className="degrad" text={"REALIZAR PAGO"}></Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ComoPagarMembresia
